import { DEFAULT_FAQ_FILTER } from 'constants/common'
import FAQTypes from 'store/actionTypes/faq'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: DEFAULT_FAQ_FILTER,
  components: {
    list: [],
    pagination: {}
  }
}

const faq = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case FAQTypes.GET_FAQS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case FAQTypes.GET_FAQ_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload
      }
    case FAQTypes.UPDATE_FILTER_FAQ_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default faq
